class SingleWorkSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const swiperNum = document.querySelectorAll(".swiper-slide");
    // if( swiperNum.length === 0  ){
    //   const worksGallery = document.querySelector(".p-single-swiper");
    //   worksGallery.classList.add("is-hidden");
    // }
    // const swiper = new Swiper(".p-single-swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 24,
    //   centeredSlides: true,
    //   speed: 800,      
    //   breakpoints: {
    //     spaceBetween: 50,
    //     768: {
    //       slidesPerView: 1.3,
    //     }
    //   },
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true 
    //   },
    
    //   // ナビボタンが必要なら追加
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });

    
    if ($('.slider').length > 0) {
      const $slider = $('.slider'); // $sliderを定義
      const $current = $('.swiper-scrollbar .current'); // $currentを定義
    
      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        arrows: true,
        centerMode: true,
        centerPadding: '25%',
        variableWidth: true,
        prevArrow: '.swiper-button-prev', // 前へボタン
        nextArrow: '.swiper-button-next', // 次へボタン
        infinite: false,

        responsive: [
          {
            breakpoint: 768, // 768px以下の場合
            settings: {
              centerMode: true,
              centerPadding: '15%',
            }
          }
        ]
      });
    
      function updateScrollbar(currentSlide, slideCount) {
        const percentage = ((currentSlide + 1) / slideCount) * 100;
        $current.css('width', `${percentage}%`);
      }
    
      // 初期化時
      const slideCount = $slider.slick('getSlick').slideCount;
      updateScrollbar(0, slideCount);
    
      // スライド変更時
      $slider.on('afterChange', function (event, slick, currentSlide) {
        updateScrollbar(currentSlide, slick.slideCount);
      });
    }
    



    // if( 3 < swiperNum.length ){
    //   const swiperBtn = document.querySelector(".single-works__swiper-naviWrap");
    //   swiperBtn.classList.add("is-hidden");
    // }

    // if( swiperNum.length === 0  ){
    //   const worksGallery = document.querySelector(".single-works__gallery");
    //   worksGallery.classList.add("is-hidden");
    // }

    // const swiper = new Swiper(".p-single-swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 24,
    //   speed: 800,      
    //   breakpoints: {
    //     spaceBetween: 50,
    //     768: {
    //       slidesPerView: 2.4,
    //     }
    //   },
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true 
    //   },
    
    //   // ナビボタンが必要なら追加
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });

  }
}

